<script>
  import {fade} from 'svelte/transition';

  export let color = '#aaa';
  export let size = 14;
  export let fullscreen = false;
  export let backgroundColor = 'transparent';
  export let style = '';
</script>

<div class="spinner" class:fullscreen={fullscreen} style="{style}; background-color: {backgroundColor};">
  <div class="bounce1" style="background: {color};width: {size}px;height: {size}px"></div>
  <div class="bounce2" style="background: {color};width: {size}px;height: {size}px"></div>
  <div class="bounce3" style="background: {color};width: {size}px;height: {size}px"></div>
</div>

<style>
  .spinner {
    text-align: center;
  }

  .spinner.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .spinner > div {
    width: 18px;
    height: 18px;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
      }
  }
</style>